import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import type { CategoryAllowedOsUpdate } from '@rocksoft/shared';

export type LocationAllowedOsUpdateState = EntityState<CategoryAllowedOsUpdate>;

export function selectId(update: CategoryAllowedOsUpdate) {
  return `${update.categoryId}-${update.productKey}-${update.version}`;
}

export const adapter: EntityAdapter<CategoryAllowedOsUpdate> = createEntityAdapter<CategoryAllowedOsUpdate>({
  selectId,
});

export const initialState: LocationAllowedOsUpdateState = adapter.getInitialState();
